import Fingerprint2 from 'fingerprintjs2';
import Cookies from 'js-cookie';
const fingerprint = {
  state: {
    fingerId: ''
  },
  mutations: {
    SET_FINGER_ID: (state,fingerId) => {
      state.fingerId = fingerId;
    }
  },
  actions: {
    getFingerId({ commit }){
      return new Promise((resolve, reject) => {
        if(Cookies.get('fingerId')){
          let fingerId = Cookies.get('fingerId');
          // 独立链接不保存fingerID的cookies
          // if (window.location.pathname.indexOf('/cloudGame/single') === -1) {
          //   Cookies.set('fingerId',fingerId, {expires: 12*30});
          // }
          commit('SET_FINGER_ID',fingerId);
          return resolve();
        }else{
          Fingerprint2.get(async function(components) {
            const values = components.map(function (component, index) {
              if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                return component.value.replace(/\bNetType\/\w+\b/, '');
              }
              return component.value;
            });
            // 生成最终id murmur
            const fingerId = Fingerprint2.x64hash128(values.join(''), 31);
            // 独立链接不保存fingerID的cookies
            // if (window.location.pathname.indexOf('/cloudGame/single') === -1) {
            //   Cookies.set('fingerId',fingerId, {expires: 12*30});
            // }
            commit('SET_FINGER_ID',fingerId);
            return resolve();
          });
        }
      });
    }
  }
};
export default fingerprint;


